/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdRowProps } from '../layout/type';
import { PropType } from 'vue';

export default {
  /** 列之间的间距（默认单位px） */
  gutter: {
    type: [String, Number] as PropType<TdRowProps['gutter']>,
  },
};
